import LOGO from "../../2025_mens_a/images/cerveceros.png";

export const Team__Cerveceros_2 = {
  name: "Cerveceros 2.0",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#3d0003",
  teamJerseyColor: "#E6DE0B",

  // Stats
  gamesWon: 0,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 31 + 46 + 46,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 23 + 26 + 29,
    },
  ],
};
